
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as n from "@/types/notifications";
import CodeMirrorWrapper from "@/components/Reusable/CustomInputs/3rdPartyWrappers/CodeMirrorWrapper.vue";

@Component({
  components: {
    CodeMirrorWrapper
  }
})
export default class StackTrace extends Vue {
  @Prop()
  value!: n.InternalServerErrorDetailsTrace[];

  getSnippetFromTrace(trace: n.InternalServerErrorDetailsTrace) {
    return Object.values(trace.snippet).join("");
  }

  getErrorLineFromTrace(trace: n.InternalServerErrorDetailsTrace) {
    return Math.max(1, trace.line - trace.startingLine + 1);
  }
}
